export class PopupFailedToOpenError extends Error {
    constructor() {
        super('Failed to open popup window');
    }
}
/**
 * Generates window.open options string for a centered popup.
 * Centers the popup relative to the browser window.
 */
export function getCenteredPopupOptions(args = {}) {
    const { width = 800, height = 800 } = args;
    const left = Math.round((window.screenX ?? 0) + (window.outerWidth - width) / 2);
    const top = Math.round((window.screenY ?? 0) + (window.outerHeight - height) / 2);
    return `width=${width},height=${height},left=${left},top=${top},popup=1`;
}
/**
 * Opens a URL in a popup window and polls for when it closes.
 * Returns a promise that resolves when the popup is closed.
 *
 * @returns Promise that resolves when the popup is closed
 */
export function openPopup(args) {
    const { url, name, options = getCenteredPopupOptions(), pollIntervalMs = 500 } = args;
    return new Promise((resolve, reject) => {
        const popup = window.open(url, name, options);
        if (!popup) {
            reject(new PopupFailedToOpenError());
            return;
        }
        const checkPopupClosed = setInterval(() => {
            if (popup.closed) {
                clearInterval(checkPopupClosed);
                resolve();
            }
        }, pollIntervalMs);
    });
}
//# sourceMappingURL=popupUtils.js.map